/*  */
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { UrlValidationService } from '@nrwl/common-lib';
import {
  BaseSetupTab,
  IComponentStateHistory,
  IValueChangedEvent,
  outputParams,
  REMOVED
} from '@nrwl/test-setup';
import { Subject, Subscription } from 'rxjs';
import { ServiceSetupService } from '../../service-setup.service';

@Component({
  selector: 'nrwl-service-setup-advance-tab',
  templateUrl: './service-setup-advance-tab.component.html',
  styleUrls: ['./service-setup-advance-tab.component.scss']
})
export class ServiceSetupAdvanceTabComponent implements OnInit {
  @ViewChild('advanceForm', { static: true }) form: NgForm;
  @ViewChild('proxyForm', { static: true }) form1: NgForm;
  @Input() tab: BaseSetupTab;
  @Input() componentId: string;
  @Input() stateHistory?: IComponentStateHistory;
  // eslint-disable-next-line @typescript-eslint/ban-types
  @Input() restoreValues?: Function;
  @Input() previousOutput: outputParams;
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onDataValueChange = new EventEmitter<IValueChangedEvent>();
  readonly unsubscribe: Subject<void> = new Subject();
  proxyURLValidationMsg: string;
  proxyURLValid: boolean;
  proxyURL: string;
  webProxyOption: string;
  proxyURLMsg: string;
  tabsubscription: Subscription;
  proxyConfig = {
    config: {
      useDefault: true,
      proxyURL: null
    }
  };
  constructor(
    public setupService: ServiceSetupService,
    private urlValidationService: UrlValidationService
  ) {
    this.webProxyOption = 'Default';
  }

  ngOnInit(): void {
    this.tab.form = this.form;
    this.restoreFormValues();
  }

  restoreFormValues(): void {
    this.restoreConfig();
  }

  selectProxy(proxyType: string): void {
    this.webProxyOption = proxyType;
    this.proxyURL = '';
    if (proxyType === 'Custom') {
      this.proxyConfig.config.useDefault = false;
      if (this.proxyURLValid) {
        this.proxyConfig.config.proxyURL = this.proxyURL;
        this.onDataEmit('proxyConfig', this.setMetaData('Custom', this.proxyURL), true);
      } else {
        this.onDataEmit('proxyConfig', this.proxyConfig, false);
      }
    } else if (proxyType === 'None') {
      this.proxyConfig.config.useDefault = false;
      this.onDataEmit('proxyConfig', this.setMetaData('None', null), true);
    } else {
      this.onDataEmit('proxyConfig', this.setMetaData('Default', null), true);
    }
  }

  proxyURLChange(): void {
    if (this.proxyURL) {
      const urlValidation = this.urlValidationService.isUrlValid(this.proxyURL);
      if (!urlValidation.isValidUrl) {
        this.form1.controls.proxyURL?.setErrors({ regex: 'wrong' });
        this.proxyURLValid = urlValidation.isValidUrl;
        this.proxyURLValidationMsg = urlValidation.errorMessage;
        this.form1.controls.proxyURL?.markAsDirty();
        this.proxyConfig.config.proxyURL = this.proxyURL;
        this.onDataEmit('proxyConfig', this.proxyConfig, false);
      } else {
        this.proxyConfig.config.proxyURL = this.proxyURL;
        this.onDataEmit('proxyConfig', this.setMetaData('Custom', this.proxyURL), true);
      }
    } else {
      this.onDataEmit('proxyConfig', this.proxyConfig, false);
    }
  }

  // eslint-disable-next-line
  onDataEmit(key: string, newValue: any, isValid: boolean): void {
    this.onDataValueChange.emit({
      componentId: this.componentId,
      key: key,
      newValue: newValue,
      isValid: isValid
    });
  }

  restoreConfig(): void {
    const originalValue = this.stateHistory(this.componentId, 'proxyConfig')?.value?.[0];
    if (originalValue && originalValue.value && originalValue.value !== REMOVED) {
      this.webProxyOption = this.setWebProxyOption(originalValue.value);
      this.onDataEmit('proxyConfig', this.webProxyOption, true);
    }
  }
  // eslint-disable-next-line
  setMetaData(option, url) {
    if (!/^http?:\/\//i.test(url) && !/^https?:\/\//i.test(url)) {
      url = 'http://' + url;
    }
    return [
      {
        key: 'web-proxy',
        value: JSON.stringify(this._makeOutput(option, url))
      }
    ];
  }
  // eslint-disable-next-line
  _makeOutput(option: string, url: string) {
    let config;
    if (url) {
      config = this.splitURL(url);
    }
    const proxyConfig = {
      config: {
        useDefault: true,
        protocol: null,
        address: null,
        port: null
      }
    };

    if (this.webProxyOption === 'None') {
      proxyConfig.config.useDefault = false;
    } else if (this.webProxyOption === 'Custom') {
      proxyConfig.config.useDefault = false;
      proxyConfig.config.protocol = config.protocol.replace(':', '');
      proxyConfig.config.address = config.address;
      proxyConfig.config.port = this._choosePort(config.protocol, config.port);
    }
    return proxyConfig;
  }

  // eslint-disable-next-line
  _choosePort(protocol: string, port: number): any {
    if (protocol === 'http:') {
      return !port ? 80 : port;
    } else {
      return !port ? 443 : port;
    }
  }
  //eslint-disable-next-line
  splitURL(url: string): any {
    return {
      protocol: new URL(url).protocol,
      address: new URL(url).hostname,
      port: new URL(url).port
    };
  }
  setWebProxyOption(value: string): string {
    const useDefault = JSON.parse(value).config.useDefault;
    const protocol = JSON.parse(value).config.protocol;
    const address = JSON.parse(value).config.address;
    const port = JSON.parse(value).config.port;
    if (useDefault) {
      return 'Default';
    } else if (!useDefault && protocol) {
      this.proxyURL = `${protocol}://${address}`;
      if (port) {
        this.proxyURL = `${this.proxyURL}:${port}`;
      }
      return 'Custom';
    }
    return 'None';
  }
}
